import Index from 'src/pages/Products/Index.vue'
import Create from 'src/pages/Products/Create.vue'
import Edit from 'src/pages/Products/Edit.vue'
import Show from 'src/pages/Products/Show.vue'

const auth = { requiresAuth: true }
const saveFrom = { saveFrom: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/products',
    name: 'Produkte',
    component: Index,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/products/create',
    name: 'Produkt Erstellen',
    component: Create,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/products/:id',
    name: 'Produkt',
    component: Show,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/products/:id/edit',
    name: 'Produkt Bearbeiten',
    component: Edit,
    meta: { ...auth, ...notUser, ...saveFrom }
  }
]
